import { LightbulbQuestionIcon } from './LightbulbQuestionIcon';

/**
 * author: Michael Irigoyen
 * id CB600C6A-E43E-4723-A8F0-963222692C23
 * name lightbulb-question
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-question.svg
 * tags
 * - Home Automation 
 */
export const LightbulbHelpIcon = LightbulbQuestionIcon;
export default LightbulbHelpIcon